import type { TimelineItemResponseDTO as TimelineItem } from "web_myplann/Infrastructure/Api/Api";
import { CATEGORY_PRIORITY } from "web_myplann/NotificationCenter/Utils/categoryPriority";

type SortDirection = "asc" | "desc";

const compareString = (a: string, b: string): number => {
	if (a < b) return -1;
	if (a > b) return 1;
	return 0;
};

const compareTitle = (a: string, b: string): number =>
	a.localeCompare(b, "cs", { sensitivity: "base" });

const buildComparator = (direction: SortDirection) => {
	const dateMultiplier = direction === "asc" ? 1 : -1;
	const timeMultiplier = direction === "asc" ? 1 : -1;

	return (a: TimelineItem, b: TimelineItem): number => {
		const byDate = compareString(a.date, b.date);
		if (byDate !== 0) {
			return byDate * dateMultiplier;
		}

		const aTime =
			typeof a.time === "string" && a.time.length > 0 ? a.time : null;
		const bTime =
			typeof b.time === "string" && b.time.length > 0 ? b.time : null;

		if (aTime !== null && bTime !== null) {
			const byTime = compareString(aTime, bTime);
			if (byTime !== 0) return byTime * timeMultiplier;
			return compareTitle(a.title, b.title);
		}

		if (aTime !== null && bTime === null) return -1;
		if (aTime === null && bTime !== null) return 1;

		const byCategory =
			CATEGORY_PRIORITY[a.category] - CATEGORY_PRIORITY[b.category];
		if (byCategory !== 0) {
			return byCategory;
		}

		return compareTitle(a.title, b.title);
	};
};

const ascendingComparator = buildComparator("asc");
const descendingComparator = buildComparator("desc");

export const sortTimelineItems = (items: TimelineItem[]): TimelineItem[] => {
	return [...items].sort(ascendingComparator);
};

export const sortTimelineItemsDescending = (
	items: TimelineItem[],
): TimelineItem[] => {
	return [...items].sort(descendingComparator);
};
